module.exports = __webpack_public_path__ + "img/octopus_wire_cleaning.b85f69df.png";